(() => {
  const configs = new Map();
  async function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.closest('form');
    const submit = form.querySelector('[name=add]');
    const status = root.querySelector('[data-popy-legacy-status]');
    form.noValidate = false;
    form.enctype = 'multipart/form-data';
    const sync = () => {
      root.querySelectorAll('[data-option-field]').forEach(wrapper => {
        const conditions = JSON.parse(wrapper.dataset.conditions);
        const visible = !conditions.length || conditions.some(condition =>
          [...root.querySelectorAll('[data-option-label]')].some(input => input.dataset.optionLabel === condition.field && input.value === condition.value));
        wrapper.hidden = !visible;
        const input = wrapper.querySelector('input, select');
        input.disabled = !visible;
        input.required = visible && wrapper.dataset.required === 'true';
      });
    };
    try {
      const url = root.dataset.configUrl;
      if (!configs.has(url)) configs.set(url, fetch(url).then(response => {
        if (!response.ok) throw Error('Options unavailable');
        return response.json();
      }));
      const options = (await configs.get(url))[root.dataset.productId];
      if (!options?.length) throw Error('Missing personalization options');
      options.forEach((option, index) => {
        const wrapper = document.createElement('div');
        wrapper.dataset.optionField = '';
        wrapper.dataset.conditions = JSON.stringify(option.conditions);
        wrapper.dataset.required = String(option.required);
        const id = `${form.id}-custom-${index}`;
        const label = document.createElement('label');
        label.htmlFor = id;
        label.textContent = option.label;
        wrapper.append(label);
        const input = document.createElement(option.values.length ? 'select' : 'input');
        input.id = id;
        input.name = `properties[${option.label}]`;
        input.dataset.optionLabel = option.label;
        if (option.values.length) {
          option.values.forEach(value => input.add(new Option(value, value, false, value === option.default)));
        } else {
          input.type = option.type === 'file' ? 'file' : 'text';
          if (input.type === 'text') input.maxLength = 100;
        }
        wrapper.append(input);
        if (input.type === 'file') {
          input.accept = 'image/jpeg,image/png';
          const card = document.createElement('div');
          card.className = 'popy-upload';
          input.className = 'popy-upload__input';
          card.append(input);
          const visual = document.createElement('span');
          visual.className = 'popy-upload__visual';
          visual.setAttribute('aria-hidden', 'true');
          const preview = document.createElement('img');
          preview.className = 'popy-upload__preview';
          preview.alt = ''; preview.width = 64; preview.height = 64; preview.hidden = true;
          const name = document.createElement('span'); name.className = 'popy-upload__copy'; name.textContent = 'Choose a favorite JPG or PNG';
          const action = document.createElement('span'); action.className = 'popy-upload__button'; action.textContent = 'Choose photo';
          visual.append(preview, name, action); card.append(visual); wrapper.append(card);
          const hint = document.createElement('p'); hint.className = 'popy-upload__status'; hint.id = `${id}-status`; hint.setAttribute('aria-live', 'polite'); hint.textContent = 'JPG or PNG, up to 10 MB.'; wrapper.append(hint); input.setAttribute('aria-describedby', hint.id);
          let objectUrl;
          input.addEventListener('change', () => {
            const file = input.files[0];
            const error = file && (file.size > 10 * 1024 * 1024 || !['image/jpeg', 'image/png'].includes(file.type)) ? 'Please choose a JPG or PNG image up to 10 MB.' : '';
            input.setCustomValidity(error);
            if (objectUrl) URL.revokeObjectURL(objectUrl);
            objectUrl = null; preview.hidden = true; preview.removeAttribute('src');
            name.textContent = file?.name || 'Choose a favorite JPG or PNG';
            action.textContent = file ? 'Change photo' : 'Choose photo';
            card.classList.toggle('is-selected', Boolean(file && !error));
            card.classList.toggle('has-error', Boolean(error));
            hint.textContent = error || (file ? 'Photo selected. Add to cart to save it with your piece.' : 'JPG or PNG, up to 10 MB.');
            if (file && !error) { objectUrl = URL.createObjectURL(file); preview.src = objectUrl; preview.hidden = false; }
            input.reportValidity();
          });
        }
        root.append(wrapper);
      });
      root.addEventListener('change', sync);
      sync();
      status.remove();
      root.dataset.ready = 'true';
      if (submit.dataset.legacyAvailable === 'true') submit.disabled = false;
    } catch {
      status.textContent = 'Personalization could not load. Please refresh this page before ordering.';
      submit.disabled = true;
    }
  }
  document.querySelectorAll('[data-popy-legacy]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-popy-legacy]').forEach(initialize));
})();
